import { render, staticRenderFns } from "./EventMetadata.vue?vue&type=template&id=3ecbc632"
import script from "./EventMetadata.vue?vue&type=script&lang=js"
export * from "./EventMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports